<template>
    <div class="footer">
        <div class="cwrap">
            <div class="lefts">
                <div class="tit">金基窝</div>
                <div class="foot-links">
                    <!-- <span><a :href="__C.urlForJjw+'/toNotePage'">投资者权益须知</a></span> -->
                   <span><a :href="__C.urlForJjw+'/tzzqyxz.html'">投资者权益须知</a></span>
                    <!-- <span><a :href="__C.urlForJjw+'/toWarnPage'">风险提示函</a></span> -->
                   <span><a :href="__C.urlForJjw+'/fxtsh.html'">风险提示函</a></span>
                    <span><a :href="__C.urlForJjw+'/topublicity'">公示信息</a></span>
                </div>
                <div class="info clearfix">
                    <div class="sprite foot-logo"></div>
                    <p>
                        办公地址：辽宁省沈阳市浑南区白塔二南街18-2号B座601<i class="emsp"></i>邮编：110169<br>
                        版权所有<i class="emsp"></i>财咨道信息技术有限公司<i class="emsp"></i><a href="http://www.miibeian.gov.cn" target="_blank">辽ICP备11018762号-4</a><i class="emsp"></i><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21011202000123" target="_blank">辽公网安备21011202000123号</a>
                        <span class="sprite"></span>
                    </p>
                </div>
                <div class="tips" style="margin-top:20px;float:left">
                    <p>数据来源：恒生-聚源数据库</p>
                    <p>数据仅供参考，不构成对投资者收益及本金不受损失的任何保证，基金及理财产品的信息和数据由管理人提</p>
                    <p>供，我司不保证信息的准确性和真实性，基金及理财产品的过往业绩并不预示其未来表现。管理人管理的其</p>
                    <p>他基金及理财产品的业绩并不构成基金及理财产品业绩表现的保证，产品收益具有波动风险。</p>
                    <p>投资者应注意投资风险，认真阅读基金产品信息、产品合同等相关法律文件，理解相关业务规则、重</p>
                    <p>要声明及风险提示的全部内容，自主做出投资决策，并自行承担投资风险，市场有风险投资需谨慎。</p>
                </div>
            </div>
            <div class="rights">
                <div class="wechat">
                    <img src="/accountcenter/static/images/wechat-ercode.png" alt="">
                    <span>微信公众号:<i>jinjiwo2018</i></span>
                </div>
                <div class="contact-infos">
                    <strong>客服/投诉热线：</strong>
                    <p>
                        <span class="tel">400-003-5811</span>
                        <span class="date">(工作日上午9:00-下午18:00)</span>
                    </p>
                    <strong>客服/投诉邮箱：</strong>
                    <p>
                        <span class="email">jijin@win-stock.com.cn</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="copyright">
            <div class="cwraps">
                © Copyright ©2007-2015 财咨道信息技术有限公司 版权所有 辽ICP备11018762号-4
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'bottom'
    }
</script>

<style lang="scss" scoped>
    @import  "../sass/mixin";
    // 页面底部
    .footer{
        background-color:#252525;
    }
    .cwrap {
        margin: 0 auto;
        width: 1200px;
    }
    .cwraps {
        margin: 0 auto;
        width: 1200px;
        text-align: center;
    }
    .copyright {
        margin-top: 20px;
        line-height: 38px;
        background-color: #1a1a1a;
        color: #666;
    }
    .info .foot-logo, .info p, .lefts, .logo, .rights .wechat {
        float: left;
    }
    .info a, .info p {
        color: #777;
        padding-left: 10px;
        margin-top: 10px;
    }
    .rights {
        padding-top: 30px;
        padding-left: 50px;
    }
    .tit {
        color: #b4b4b4;
        font-size: 16px;
        margin-top: 30px;
    }
    .foot-links {
        padding: 10px 0;
        font-size: 0;
    }
    .foot-links span {
        display: inline-block;
        line-height: 1;
        font-size: 14px;
    }

    .foot-links span+span {
        border-left: 1px solid #666;
        margin-left: 20px;
        padding-left: 20px;
    }

    .foot-links span a {
        color: #9e9e9e;
    }

    .foot-links span a:hover {
        color: #fff !important;
    }

    .tips {
        margin-top: 53px;
        color: #777;
    }
    .info .foot-logo {
        margin-top: 11px;
        width: 34px;
        height: 38px;
        background-position: -113px 0;
    }

    .sprite {
        background: url(/accountcenter/static/images/sprite.png) no-repeat;
    }
    .info p span {
        position: relative;
        top: 4px;
        margin-left: 10px;
        display: inline-block;
        width: 18px;
        height: 20px;
        background-position: -147px 0;
    }
    .emsp {
        display: inline-block;
        width: 14px;
    }

    .rights .wechat {
        margin-right: 50px;
        padding-top: 5px;
        width: 150px;
        text-align: center;
        margin-left: 80px;
        color: #9e9e9e;
        font-size: 12px;
    }
    .rights .wechat img {
        display: block;
        margin: 0 auto 10px;
        width: 120px;
        height: 120px;
    }
    .rights .contact-infos {
        float: left;
        width: 180px;
    }
    .rights .contact-infos p .tel {
        margin-bottom: 5px;
        font-size: 20px;
        color: #9e9e9e;
    }
    .rights .contact-infos p .date {
        color: #777;
    }
    .rights .contact-infos p .email {
        color: #9e9e9e;
    }
    .info p {
        margin-left:15px;
        padding-top:5px;
        line-height:22px;
    }
    .rights .contact-infos strong{
        display:block;
        margin-bottom:5px;
        color:#777!important;
    }
    .rights .wechat span {
        display:block;
        color:#777;
        font-size:12px;
    }
    .rights .wechat span i {
        font-style: normal;
        color: #9e9e9e;
    }
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue